module.exports = __webpack_public_path__ + "static/media/Administracion3.88ab332.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audios/Administracion3.mp3
// module id = 710
// module chunks = 1